import React, { useEffect } from 'react';
import { Form } from '@ant-design/compatible';

import { CATEGORY_EXHIBIT_TYPE, CATEGORY_STATUS_TYPE } from '../../../../constants/service/app/categoryConstants';
import CategoryExhibitSaveNavBar from './CategoryExhibitSaveNavBar';
import { useExhibitCategory } from './hooks/useExhibitCategory';
import { useTotalCategory } from './hooks/useTotalCategory';
import useCategoryListTree from '../../../../hooks/queries/category/useCategoryListTree';
import { useCategoryExhibitNavbar } from './hooks/useCategoryExhibitNavbar';
import { useCategoryController } from './hooks/useCategoryController';
import ExhibitCategory from './ExhibitCategory';
import CategoryController from './CategoryController';
import TotalCategory from './TotalCategory';
import './CategoryExhibitManagementWrap.scss';

const CategoryExhibitManagementWrap = (props) => {
  const { form } = props;

  // 카테고리 리스트 트리
  const { data } = useCategoryListTree();

  //전시 카테고리 상태 및 로직
  const {
    exhibitCategoryTabType,
    setExhibitCategoryDataSource,
    exhibitGeneralCategoryDataSource,
    exhibitEmphasisCategoryDataSource,
    selectedExhibitMainCategoryList,
    selectedExhibitSubCategoryList,
    setExhibitEmphasisCategoryDataSource,
    setExhibitGeneralCategoryDataSource,
    setExhibitCategoryTabType,
    setSelectedExhibitMainCategoryList,
    setSelectedExhibitSubCategoryList,
    onDragEnd,
    onSelectExhibit,
    onSelectAllExhibit,
  } = useExhibitCategory();

  //카테고리 리스트 상태 및 로직
  const {
    totalCategoryDataSource,
    totalCategoryTabType,
    setTotalCategoryTabType,
    totalCategoryRowSelection,
    setTotalCategoryDataSource,
    selectedTotalMainCategoryList,
    selectedTotalSubCategoryList,
    setSelectedTotalMainCategoryList,
    setSelectedTotalSubCategoryList,
  } = useTotalCategory();

  //하단 바의 편집 및 저장 로직
  const { isEditable, setIsEditable, onSubmit } = useCategoryExhibitNavbar({
    form,
    exhibitGeneralCategoryDataSource,
    exhibitEmphasisCategoryDataSource,
    setSelectedExhibitMainCategoryList,
    setSelectedExhibitSubCategoryList,
    setSelectedTotalMainCategoryList,
    setSelectedTotalSubCategoryList,
  });

  //전시 카테고리와 카테고리 리스트 사이의 제외 및 추가 로직
  const { onInexhibit, onExhibit, onDeleteExhibitCategory } = useCategoryController({
    exhibitGeneralCategoryDataSource,
    exhibitEmphasisCategoryDataSource,
    exhibitCategoryTabType,
    totalCategoryTabType,
    setTotalCategoryDataSource,
    selectedTotalMainCategoryList,
    selectedTotalSubCategoryList,
    selectedExhibitMainCategoryList,
    selectedExhibitSubCategoryList,
    setSelectedExhibitMainCategoryList,
    setSelectedExhibitSubCategoryList,
    setExhibitGeneralCategoryDataSource,
    setExhibitEmphasisCategoryDataSource,
    setSelectedTotalMainCategoryList,
    setSelectedTotalSubCategoryList,
  });

  // 서버 데이터가 변경되었을 때 전시, 전체 카테고리 리스트 필터링
  useEffect(() => {
    const newData = data?.categories.map(({ subCategories, ...res }) => ({
      ...res,
      children: subCategories.map((subCategory) => ({
        ...subCategory,
        parentStatus: res.status,
        parentType: res.type,
      })),
    }));

    // 전시 카테고리 리스트 필터링
    setExhibitCategoryDataSource(
      newData
        ?.filter((mainCategory) => mainCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT)
        .map((mainCategory) => ({
          ...mainCategory,
          children: mainCategory.children.filter(
            (sub) => sub.status === CATEGORY_STATUS_TYPE.ACTIVE && sub.isExhibit === CATEGORY_EXHIBIT_TYPE.EXHIBIT,
          ),
        })),
    );

    // 전체 카테고리 리스트 필터링
    setTotalCategoryDataSource(newData);
  }, [data]);

  return (
    <div className="category-exhibit-management-wrap">
      {/*전시 카테고리*/}
      <ExhibitCategory
        onDragEnd={onDragEnd}
        isEditable={isEditable}
        onDelete={onDeleteExhibitCategory}
        selectedExhibitMainCategoryList={selectedExhibitMainCategoryList}
        selectedExhibitSubCategoryList={selectedExhibitSubCategoryList}
        exhibitCategoryTabType={exhibitCategoryTabType}
        exhibitEmphasisCategoryDataSource={exhibitEmphasisCategoryDataSource}
        onSelectExhibit={onSelectExhibit}
        onSelectAllExhibit={onSelectAllExhibit}
        setExhibitCategoryTabType={setExhibitCategoryTabType}
        exhibitGeneralCategoryDataSource={exhibitGeneralCategoryDataSource}
      />
      {/*제외 및 추가 버튼*/}
      <CategoryController
        isShow={isEditable}
        isExhibitDisable={!selectedTotalMainCategoryList.length && !selectedTotalSubCategoryList.length}
        isInexhibitDisable={!selectedExhibitMainCategoryList.length && !selectedExhibitSubCategoryList.length}
        onInexhibit={onInexhibit}
        onExhibit={onExhibit}
      />
      {/*카테고리 리스트*/}
      <TotalCategory
        form={form}
        isShow={isEditable}
        totalCategoryTabType={totalCategoryTabType}
        totalCategoryRowSelection={totalCategoryRowSelection}
        setTotalCategoryTabType={setTotalCategoryTabType}
        totalCategoryDataSource={totalCategoryDataSource}
      />
      {/*하단 바*/}
      <CategoryExhibitSaveNavBar
        isEditable={isEditable}
        setIsEditable={setIsEditable}
        exhibitGeneralCategoryDataSource={exhibitGeneralCategoryDataSource}
        exhibitEmphasisCategoryDataSource={exhibitEmphasisCategoryDataSource}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default Form.create()(CategoryExhibitManagementWrap);
